import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type CustomerLayoutMode = 'grid' | 'list';

interface CustomersUiStore {
  layoutMode: CustomerLayoutMode;
  setLayoutMode: (mode: CustomerLayoutMode) => void;
}

export const useCustomersUiStore = create<CustomersUiStore>()(
  persist(
    (set) => ({
      layoutMode: 'grid',
      setLayoutMode: (layoutMode) => set({ layoutMode }),
    }),
    {
      name: 'customers-ui-prefs',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
